import { Component, EventEmitter, Input, Output, AfterViewInit, ChangeDetectorRef, OnChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_SELECT_CONFIG, MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-page-select',
  templateUrl: './page-select.component.html',
  styleUrls: ['./page-select.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'custom-overlayer-select-input' }
    }
  ]
})
export class PageSelectComponent implements AfterViewInit, OnChanges {
  @ViewChild('selectPage') selectPage!: MatSelect;

  @Input() length: number;
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[];
  @Input() selectedPage = 1;
  @Input() sizeMin = false
  @Input() removeBackground = true;

  @Output() itensOutput = new EventEmitter();
  @Output() emitPageSelected = new EventEmitter();

  select = new FormControl();
  pages;
  count = 0;
  maxPages: number;
  beforeValue = this.selectedPage;

  constructor(private readonly cdr: ChangeDetectorRef) {
    this.cdr = cdr;
  }

  verifySelectedValue(): void {
    if (this.selectedPage >= 1 && this.selectedPage <= this.maxPages) {
      this.beforeValue = this.selectedPage;
    } else if ((!this.selectedPage && this.selectedPage === 0) || this.selectedPage > this.maxPages) {
      this.selectedPage = this.beforeValue;
    }
  }

  openedSelect(event): void {
    if (event) {
      const positions = this.selectPage._elementRef.nativeElement.getBoundingClientRect();
      const elmentOverlay: any = document.querySelector('.custom-overlayer-select-input');
      if (elmentOverlay) {
        elmentOverlay.style.top = `${positions.top}px`;
        elmentOverlay.style.bottom = `auto`;
      }
    }
  }

  generateMaxPages() {
    this.maxPages = Math.ceil(this.length / this.pageSize);
  }

  ngOnChanges() {
    this.pagesNumber();
    this.generateMaxPages();
    this.beforeValue = this.selectedPage;
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  pagesNumber() {
    this.selectedPage = this.selectedPage === undefined ? 1 : this.selectedPage;

    if (this.count === 0) {
      this.pageSizeOptions.push(this.length);
      this.count++;
    }
    this.pageSizeOptions[this.pageSizeOptions.length - 1] = this.length;
    if (this.pageSize === 0) {
      this.pages = 1;
    } else {
      this.pages = Math.ceil(this.length / this.pageSize);
    }
    if (this.length < this.pageSize) {
      this.select.setValue(this.length);
    } else {
      this.select.setValue(this.pageSize);
    }
  }

  changePag(op) {
    if (op === '+' && this.selectedPage < this.pages) {
      this.selectedPage++;
      this.emitPageSelected.emit(this.selectedPage);
    } else if (op === '-' && this.selectedPage > 1) {
      this.selectedPage--;
      this.emitPageSelected.emit(this.selectedPage);
    }
    this.beforeValue = this.selectedPage;
  }

  switchToThisPage(idx) {
    if (!idx && idx !== 0) {
      this.selectedPage = 1;
    }
    if (idx >= 1 && idx <= this.maxPages) {
      this.selectedPage = idx;
      this.emitPageSelected.emit(this.selectedPage);
    }
  }

  changeManyItens(itens) {
    this.pageSize = itens;
    this.beforeValue = 1;
    this.selectedPage = this.beforeValue;
    this.pagesNumber();
    this.generateMaxPages();
    this.itensOutput.emit(itens);
  }

  styleObject(idx): Object {
    if (this.selectedPage === idx) {
      return {
              'background-color': '#1B4693',
              'color':'#DCE7F9',
              'font-weight': 'bold'
              };
    }
    return {};
  }
}
